var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// Core
import React from 'react';
var ComponentForm = /** @class */ (function (_super) {
    __extends(ComponentForm, _super);
    function ComponentForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Handle input text change
         * @param evt
         */
        _this.handleChange = function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (evt.target.value !== _this.state.value) {
                _this.setState({ value: evt.target.value });
                _this.callback();
            }
        };
        return _this;
    }
    /**
     * Call parent method for handling top level change
     */
    ComponentForm.prototype.callback = function (wait) {
        var onChange = this.props.onChange;
        if (onChange) {
            onChange(this.props.id, this.state.value);
        }
    };
    return ComponentForm;
}(React.Component));
export default ComponentForm;
//# sourceMappingURL=ComponentForm.js.map